import Link from "next/link";

import { popoutContainerCss } from "@/view/SecondaryActions/SecondaryActions.style";
import { noClassroomWrapperCss } from "../HideOptions.style";

interface NoClassesMessageProps {
  isMobile: boolean;
}

const NoClassesMessage = ({ isMobile }: NoClassesMessageProps) => {
  const createAClassHref = "/account/classes/";
  const css = isMobile
    ? noClassroomWrapperCss
    : { ...popoutContainerCss, ...noClassroomWrapperCss };

  return (
    <div css={css}>
      To hide this content, first
      <Link href={createAClassHref}> create a class</Link>.
    </div>
  );
};

export default NoClassesMessage;
